export const SUSTAINED = "Sustained";
export const CYCLIC = "Cyclic";
